(function () {

    const cache = new Map();
    const CATEGORY_LINKS = '.category_list-link, .shop_by_category_list a.category_list-item';
    function prefetch(url) {
    if (!cache.has(url)) cache.set(url, fetch(url).then(r => r.text()));
    }
    document.addEventListener('mouseover', function (e) {
    const link = e.target.closest(CATEGORY_LINKS);
    if (link) prefetch(link.href);
    });

document.addEventListener('touchstart', function (e) {
  const link = e.target.closest(CATEGORY_LINKS);
  if (link) prefetch(link.href);
}, { passive: true });

function swapRegion(doc, selector) {
  const cur = document.querySelector(selector);
  const fresh = doc.querySelector(selector);
  if (cur && fresh) {
    fresh.style.minHeight = cur.offsetHeight + 'px'; // hold previous height
    cur.replaceWith(fresh);
    setTimeout(() => { fresh.style.minHeight = ''; }, 600); // release after settle
  }
}

  async function loadCategory(url) {
    const container = document.querySelector('#ProductGridContainer');
    if (!container) { window.location.href = url; return; }

    container.style.opacity = '0.4';
    container.style.pointerEvents = 'none';

    try {
        const html = await (cache.get(url) || fetch(url).then(r => r.text()));
        cache.delete(url);
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('#ProductGridContainer');
      if (!fresh) { window.location.href = url; return; }

      swapRegion(doc, '[id^="shopify-section-template--"][id*="__template-header"]');
      swapRegion(doc, '#Facet-Drawer .side-panel-inner');

      container.replaceWith(fresh);
      document.title = doc.title;
      history.pushState({ categoryAjax: true }, '', url);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (e) {
      window.location.href = url; // network hiccup → normal navigation
    }
  }

  document.addEventListener('click', function (e) {
      const link = e.target.closest(CATEGORY_LINKS);
      if (!link || e.metaKey || e.ctrlKey) return; // let cmd/ctrl-click open new tabs
      e.preventDefault();
      e.stopPropagation();
      if (link.closest('#Facet-Drawer')) {
        const inner = document.querySelector('#Facet-Drawer .side-panel-inner');
        if (inner) inner.style.pointerEvents = 'none'; // freeze everything until fresh drawer arrives
        const cc = document.querySelector('.click-capture');
        if (cc) cc.click(); // close the drawer
      }
      loadCategory(link.href);
    });

    window.addEventListener('popstate', function (e) {
      if (e.state && e.state.categoryAjax) location.reload();
    });
  })();

